import { createContext } from 'react';
export var scrollTopContext = createContext([
    0,
    // eslint-disable-next-line no-console
    function () { console.log('no scrolltop context mounted'); },
    // eslint-disable-next-line no-console
    function () { console.log('no scrolltop context mounted'); },
]);
